import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesType, { namespaces } from '@i18n/manifest';
import { LanguageCode, updateLocaleLocalStorage, updateLocaleSearchParams } from '@hooks/useGeoLocale';

declare module 'i18next' {
  interface CustomTypeOptions {
    resources: typeof resourcesType;
    returnObjects: true;
  }
}

export const languages = new Map([
  ['en', 'English'],
  ['en-US', 'English (US)'],
  ['en-GB', 'English (UK)'],
  ['en-AU', 'English (AU)'],
  ['de', 'Deutsch'],
  ['es', 'Español'],
  ['fr', 'Français'],
  ['it', 'Italiano'],
  ['ja', '日本語'],
]);

const resources: Record<string, Record<string, string>> = {};

for (const language of languages.keys()) {
  for (const namespace of namespaces) {
    if (typeof resources[language] === 'undefined') {
      resources[language] = {};
    }
    resources[language][namespace] = require(`../locales/${language}/${namespace}.json`);
  }
}

// __BUILD_LOCALE__ defined when running in a Gatsby build and is used to create per-language builds
export const BUILD_LOCALE = typeof __BUILD_LOCALE__ !== 'undefined' ? __BUILD_LOCALE__ : undefined;

export const DEFAULT_LANGUAGE = BUILD_LOCALE ?? 'en-US';

i18n.use(initReactI18next).init({
  initAsync: false,
  returnObjects: true,
  ns: ['home'],
  fallbackLng: DEFAULT_LANGUAGE,
  debug: true,
  react: {
    useSuspense: true,
  },
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});

i18n.on('languageChanged', (language: LanguageCode) => {
  updateLocaleLocalStorage({ language });
  updateLocaleSearchParams({ language });
});

export default i18n;
